import React from 'react';

import { Accordion, AccordionSummary, AccordionDetails, Text } from 'shell/components';

const AccordionDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Accordion</Text>
            <Accordion>
                <AccordionSummary>
                    <Text variant={'p2'}>Accordion Summary</Text>
                </AccordionSummary>
                <AccordionDetails>
                    <Text variant={'p2'}>Accordion Details</Text>
                </AccordionDetails>
            </Accordion>
        </>
    );
};

export default AccordionDemo;
